import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap';
import { getStore } from './store/store';
import { Provider } from 'react-redux';
import { CustomToaster } from './components/toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={getStore()}>
      <React.StrictMode>
        <App />
        <CustomToaster />
      </React.StrictMode>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
